<template>
  <main class="workshop">
    <div class="workshop__siblings">
      <transition @enter="enterPrev">
        <router-link
          :to="`/${$route.params.city}/workshops/${prevWorkshop.path}`"
          class="workshop__sibling workshop__sibling--prev"
          v-if="prevWorkshop"
        >
          <AppPicture
            :data="{ src: prevWorkshop.hostPicture, alt: prevWorkshop.hostName }"
            :isImg="false"
            :lazy="false"
            ref="prev"
          />
          <span class="sibling__caption u-hidden--from-ipadL">prev</span>
          <AppButton
            :data="{
              url: `/${$route.params.city}/workshops/${prevWorkshop.path}`,
              content: 'Prev'
            }"
            :router="true"
            :hasIcon="false"
            ref="prevButton"
          />
        </router-link>
      </transition>
      <transition @enter="enterNext">
        <router-link
          :to="`/${$route.params.city}/workshops/${nextWorkshop.path}`"
          class="workshop__sibling workshop__sibling--next"
          v-if="nextWorkshop"
        >
          <AppPicture
            :data="{ src: nextWorkshop.hostPicture, alt: nextWorkshop.hostName }"
            :isImg="false"
            :lazy="false"
            ref="next"
          />
          <span class="sibling__caption u-hidden--from-ipadL">next</span>
          <AppButton
            :data="{
              url: `/${$route.params.city}/workshops/${nextWorkshop.path}`,
              content: 'Next'
            }"
            :router="true"
            :hasIcon="false"
            ref="nextButton"
          />
        </router-link>
      </transition>
    </div>

    <section class="workshop__item">
      <transition @enter="enterContent">
        <Article v-if="currentWorkshop" :key="currentWorkshop.title">
          <section class="workshop__card">
            <span class="card__bg" ref="bg"/>
            <div class="workshop__picture-cont">
              <AppPicture
                ref="picture"
                class="workshop__picture"
                :data="{
                  src: currentWorkshop.hostPicture,
                  alt: currentWorkshop.hostName,
                }"
                :isImg="false"
                :lazy="false"
              />
              <h2 class="workshop__role u-hidden--until-ipadL">
                {{ currentWorkshop.hostRole }}
              </h2>
            </div>
            <h1
              class="workshop__name c-title c-title--light"
              v-html="currentWorkshop.hostName"
              ref="title"
            />
            <ul class="workshop__contacts">
              <li>
                <a
                  :href="currentWorkshop.hostTwitter"
                  @mouseenter="$eventHub.$emit('morphCursor', 'circle')"
                  @mouseleave="$eventHub.$emit('morphCursor', 'rect')"
                >Twitter</a>
              </li>
              <li>
                <a
                  :href="currentWorkshop.hostWebsite"
                  @mouseenter="$eventHub.$emit('morphCursor', 'circle')"
                  @mouseleave="$eventHub.$emit('morphCursor', 'rect')"
                >Website</a>
              </li>
            </ul>
            <AppButton
              class="workshop__caption-card u-hidden--until-ipadL"
              :data="{
                content: 'Buy Workshop',
                url: currentLinkUniverse,
              }"
              theme="dark"
              :router="false"
              :isAnimated="false"
              data-lazyAnimation="button"
            />
          </section>

          <section class="workshop__info">
            <h2 class="workshop__role u-hidden--from-ipadL" data-lazyAnimation="button">
              {{ currentWorkshop.hostRole }}
            </h2>
            <div class="workshop__caption-cont">
              <AppButton
                class="workshop__caption-card u-hidden--from-ipadL"
                :data="{
                  content: 'Buy Workshop',
                  url: currentLinkUniverse,
                }"
                theme="dark"
                :router="false"
                :isAnimated="false"
                data-lazyAnimation="button"
              />
            </div>
            <div class="workshop__compound-cont">
              <span class="workshop__line" data-lazyanimation="line"/>
              <p
                v-html="currentWorkshop.workshopDate"
                data-lazyanimation="fade"
              />
              <span class="workshop__line" data-lazyanimation="line"/>
            </div>
            <AppTitle
              class="workshop__section-title c-title--light"
              :data="{
                content: currentWorkshop.workshopTitle,
              }"
              data-lazyanimation="title"
              :isAnimated="false"
            />
            <div
              :class="[
                'workshop__switcher',
                `switcher--${content}`
              ]"
              data-lazyanimation="fade"
            >
              <button
                class="switcher__voice"
                @click="content = 'workshop'"
              >Workshop Info</button>
              <button
                class="switcher__voice"
                @click="content = 'author'"
              >Author Info</button>
            </div>
            <div class="switcher__content" data-lazyanimation="fade">
              <p
                v-html="content === 'workshop'
                  ? currentWorkshop.workshopInfo : currentWorkshop.hostBio"
              />
              <ul
                class="switcher__extra-info"
                v-if="currentWorkshop.workshopExtraInfo !== '' && content === 'workshop'"
              >
                <li v-html="currentWorkshop.workshopExtraInfo" />
              </ul>
            </div>
          </section>

          <section class="workshop__schedule">
            <AppLine data-lazyanimation="line" :isAnimated="false"/>
            <AppTitle
              class="workshop__section-title c-title--light"
              :data="{
                content: 'Schedule',
              }"
              data-lazyanimation="title"
            />
            <AppLine data-lazyanimation="line" :isAnimated="false"/>
            <ul class="schedule__list" data-lazyanimation="fade">
              <li
                v-for="(row, key) in currentWorkshop.workshopSchedule"
                :key="key"
              ><time>{{ row.time }}</time> . {{ row.text}}</li>
            </ul>
            <div class="workshop__compound-cont">
              <span class="workshop__line" data-lazyanimation="line"/>
              <AppButton
                class="workshop__button"
                :data="{
                  content: 'Buy Workshop',
                  url: currentLinkUniverse,
                }"
                theme="dark"
                :router="false"
                :isAnimated="false"
                data-lazyanimation="button"
              />
              <span class="workshop__line" data-lazyanimation="line"/>
            </div>
          </section>
        </Article>
      </transition>
    </section>

    <AppSponsor :sponsorList="sponsors[$route.params.city]" />

    <AppFooter />
  </main>
</template>

<script>
import anime from 'animejs';
import { mapGetters } from 'vuex';

import AppLine from '@/components/AppLine.vue';
import AppTitle from '@/components/AppTitle.vue';
import AppButton from '@/components/AppButton.vue';
import AppPicture from '@/components/AppPicture.vue';
import AppFooter from '@/components/AppFooter.vue';
import AppSponsor from '@/components/AppSponsor.vue';

import medusa from '@/scripts/medusa';
import { initials, animations } from '@/scripts/fx';

import workshopsList from '@/assets/data/contents/workshops.json';
import sponsors from '@/assets/data/contents/sponsor.json';

export default {
  name: 'Workshop',
  components: {
    AppLine,
    AppTitle,
    AppButton,
    AppPicture,
    AppFooter,
    AppSponsor,
  },
  data() {
    return {
      content: 'workshop',
      data: null,
      nextWorkshop: null,
      prevWorkshop: null,
      dataAdded: false,
      currentWorkshop: null,
      workshopsList,
      sponsors,
    };
  },
  computed: {
    ...mapGetters(['contentReady', 'currentLinkUniverse']),
  },
  mounted() {
    this.setCurrent();
    this.findNextPrev();
    medusa.recalculateTargets(this.$el);
  },
  methods: {
    enter() {
      anime.set(this.$refs.picture.$el, { opacity: 0 });
      initials.get('title')(this.$refs.title);

      this.$refs.picture.loadPicture().then(() => {
        animations.get('title')(this.$refs.title);
        anime({
          targets: this.$refs.picture.$el,
          opacity: [0, 1],
          delay: 300,
        });
      });
    },

    setCurrent() {
      const cityWs = this.workshopsList[this.$route.params.city];

      const index = cityWs.workshops.findIndex(workshop => this.$route.path.includes(workshop.path)); //eslint-disable-line
      this.currentWorkshop = cityWs.workshops[index];
    },

    findNextPrev() {
      const cityWs = this.workshopsList[this.$route.params.city];
      const index = cityWs.workshops.findIndex(workshop => this.$route.path.includes(workshop.path)); //eslint-disable-line
      const prevIndex = index === 0 ? cityWs.workshops.length - 1 : index - 1;
      const nextIndex = index === cityWs.workshops.length - 1 ? 0 : index + 1;
      this.prevWorkshop = cityWs.workshops[prevIndex];
      this.nextWorkshop = cityWs.workshops[nextIndex];
    },
    enterPrev() {
      initials.get('fade')(this.$refs.prev.$el, 80);
      initials.get('button')(this.$refs.prevButton.$el);
      animations.get('fade')(this.$refs.prev.$el, 400, 0.3);
      animations.get('button')(this.$refs.prevButton.$el, 800);
    },
    enterNext() {
      initials.get('fade')(this.$refs.next.$el, 80);
      initials.get('button')(this.$refs.nextButton.$el);
      animations.get('fade')(this.$refs.next.$el, 400, 0.3);
      animations.get('button')(this.$refs.nextButton.$el, 800);
    },
    enterContent(el, done) {
      this.enter();
      const items = [...this.$el.querySelectorAll('[data-lazyanimation="fade"]')];
      const titles = [...this.$el.querySelectorAll('[data-lazyanimation="title"] h3')];
      const lines = [...this.$el.querySelectorAll('[data-lazyanimation="line"]')];

      items.forEach(item => initials.get('fade')(item, 100));
      titles.forEach(title => initials.get('title')(title, 100));
      lines.forEach(line => initials.get('line')(line, 100));

      const array = [...items, ...titles, ...lines];
      medusa.ref.pushToTarget('scrollAnimations', array);
      medusa.prevNodes.push(...array);

      done();
    },
  },
};
</script>

<style lang="scss" scoped>
.workshop {
  &__item {
    min-height: 100vh;
    min-height: calc(var(--vh, 1vh) * 100);
  }

  article {
    display: grid;
    grid-template-columns: repeat(13, 1fr);
    margin-top: $unit-vh * 0.5;

    @include mq(ds) {
      margin-top: $unit-vh * 3.5;
    }
  }

  &__card {
    position: relative;
    padding: 15px;
    margin: 0 $unit-vw * 2 $unit-vh * 2;

    grid-column: 2 / 13;

    @include mq(ipadP) {
      grid-column: 2 / 13;
      padding: 25px;
    }

    @include mq(ipadL) {
      grid-column: 3 / 11;
    }

    @include mq(ds) {
      grid-column: 4 / 10;
    }

    .card__bg {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: $color-white;

      z-index: -1;
    }
  }

  &__picture-cont {
    position: relative;

    .workshop__picture {
      @include aspect-ratio(13, 17);
    }
  }

  &__caption-cont {
    position: relative;
    width: 100%;
    text-align: center;
    margin: 0;
  }

  &__caption-card {
    position: relative;

    @include mq(ipadL) {
      position: absolute;
      bottom: -30px;
      left: 50%;

      transform: translateX(-50%);
    }
  }

  &__name {
    position: absolute;
    top: 0;
    left: -50%;
    width: 200%;
    margin: 0;
    margin-top: -0.8em;

    text-align: center;
    line-height: 1.2;

    @include fluid-type(
      375px,
      1024px,
      50px,
      135px,
      50px,
      135px
    );

    @include mq(ipadL) {
      @include fluid-type(
        1024px,
        3840px,
        56px,
        300px,
        78.4px,
        420px
      );

      line-height: 1.2 !important;
    }
  }

  &__role {
    position: relative;
    width: 100%;
    margin-top: $unit-vh;

    font-size: 1em;
    text-align: center;
    grid-row: 2;
    grid-column: 3 / 11;

    font-size: 16px;

    @include mq($from: dm) {
      font-size: 20px;
    }

    @include mq($from: dxl) {
      font-size: 24px;
    }

    @include mq(ipadL) {
      position: absolute;
      bottom: 50px;
      left: 15%;
      width: 70%;
      margin: 0;

      grid-row: unset;
      grid-column: unset;
    }
  }

  &__contacts {
    display: flex;
    align-items: baseline;
    justify-content: space-between;

    margin-top: 60px;

    a {
      color: var(--color-bg);
    }
  }

  &__info,
  &__schedule {
    grid-column: 1 / -1;

    @include mq(ipadL) {
      grid-column: 1 / 13;
    }

    @include mq(d) {
      grid-column: 2 / 12;
    }
  }

  &__section-title {
    text-align: center;
  }

  &__switcher {
    position: relative;
    width: 100%;
    margin: $unit-vh * 2 0;

    display: grid;
    grid-template-columns: repeat(2, 1fr);

    border-top: 1px solid rgba($color-white, 0.4);
    border-bottom: 1px solid rgba($color-white, 0.4);

    &.switcher--author::before {
      transform: translateX(100%);
    }

    &::before {
      content: '';

      position: absolute;
      bottom: 0;
      left: 0;
      width: 50%;
      height: 3px;

      background-color: $color-white;
      transition: transform 0.5s $outCirc;
    }

    .switcher__voice {
      position: relative;
      padding: 30px 0;

      background-color: transparent;
      border: 0;
      text-transform: uppercase;

      cursor: pointer;

      &:first-child::before {
        content: '';

        position: absolute;
        top: 20px;
        right: 0;

        width: 1px;
        height: calc(100% - 40px);

        background-color: rgba($color-white, 0.4);
      }
    }
  }

  .switcher__content {
    margin-top: $unit-vh * 5;

    font-size: 20px;

    @include mq(ipadP) {
      font-size: 16px;
    }

    @include mq(d) {
      font-size: 20px;
    }

    @include mq(dm) {
      font-size: 24px;
    }

    @include mq(dxl) {
      font-size: 26px;
    }
  }

  .switcher__extra-info {
    margin-top: $unit-vh * 3;
  }

  .workshop__compound-cont {
    display: flex;
    align-items: center;
    justify-content: space-between;

    margin: $unit-vh * 2 0;

    .workshop__line {
      position: relative;
      width: calc(50% - 150px);
      height: 1px;

      background-color: rgba($color-white, 0.4);
    }
  }

  &__schedule {
    .schedule__list {
      margin-left: 20px;

      font-size: 20px;
      line-height: 1.5;

      @include mq(ipadP) {
        font-size: 16px;
      }

      @include mq(d) {
        font-size: 20px;
      }

      @include mq(dm) {
        font-size: 24px;
        line-height: 2;
      }

      @include mq(dxl) {
        font-size: 26px;
      }

      li:before {
        content: '•'; /* Insert content that looks like bullets */
        padding-right: 15px;
        color: var(--color-headline-light); /* Or a color you prefer */
        font-size: 25px;
      }

      time {
        color: var(--color-headline-dark);
      }
    }
  }

  &__siblings {
    position: absolute;
    width: 100%;
    left: 0px;
    top: $unit-vh * 8;

    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  &__sibling {
    position: relative;
    width: 300px;
    top: $unit-vw * 3;

    z-index: 10;

    @include mq (ds) {
      top: $unit-vw * 6;
    }

    @include mq(d) {
      width: $unit-vw * 12;
    }

    &--prev {
      left: 0;
      transform: translateX(-85%);

      @include mq(ipadP) {
        transform: translateX(-70%);
      }

      @include mq(ipadL) {
        left: $unit-vw * -7;
        transform: none;
      }

      .sibling__caption {
        right: 5px;
        transform: rotate(-90deg);
      }

      .button {
        right: 0px;
        transform: rotate(-90deg) translateY(75px) translateX(25%);
      }
    }

    &--next {
      right: 0;
      transform: translateX(85%);

      @include mq(ipadP) {
        transform: translateX(70%);
      }

      @include mq(ipadL) {
        right: $unit-vw * -7;
        transform: none;
      }

      .sibling__caption {
        left: 0;
        transform: rotate(-90deg);
      }

      .button {
        left: 0px;
        transform: rotate(-90deg) translateY(-75px) translateX(25%);
      }
    }

    .sibling__caption {
      position: absolute;

      pointer-events: none;
      top: 50%;
    }

    .picture {
      @include aspect-ratio(13, 17);
      opacity: 0.3;
    }

    .button {
      position: absolute;
      top: 50%;

      @include mq($until: ipadL) {
        display: none;
      }

      & ::v-deep a {
        padding: 20px 60px;
      }
    }
  }
}
</style>
<style lang="scss">
.workshop .switcher__extra-info {
  ul,
  ul li {
    list-style: disc;
    margin-left: 1em;
  }

  b,
  strong {
    font-weight: bold;
  }
}
</style>
